import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface InfoProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const Info = ({ fill, title, height, width, ...rest }: InfoProps) => (
    <SVGBase viewBox="0 0 16.5 16.5" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8.25a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Zm8.76-3.933a.75.75 0 0 1 .055 1.059l-.008.008a.75.75 0 1 1-1.114-1.003l.007-.009a.75.75 0 0 1 1.06-.055Zm-.51 2.808a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0v-3.75a.75.75 0 0 1 .75-.75Z"
        />
    </SVGBase>
);

export default Info;
